import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'Products / Firearms',
		url: '/products',
		icon: 'barcode',
	},
	{
		name: 'IOI Inspections',
		url: '/products/ioi_inspections',
		icon: 'id-badge',
	}
];

class Ioi_Inspection extends Framework.Components.View {


	receiveCurrentIoiId = (id) => {
		this.setState({ioi_id: id})
	}

	render() {
		let {location, rootState} = this.props;
		let { locations, states, reloadShell} = rootState;
		// let {locationName, boundBookName, primaryBoundBookName} = this.state;
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/products/ioi_inspections/${this.props.id}`,
				icon: 'file-text-o',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Objects.IoiInspection
					id={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
					setIoiId={this.receiveCurrentIoiId}
				/>

				<Collections.LocationBoundBookFlags
					id={this.state.name}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
					deleteText={"Archive"}
					renderForAdmin={true}
				/>

				<Collections.LocationBoundBookFlags
					id={location}
					history={this.props.history}
					locations={locations}
					states={states}
					reloadShell={reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
					deleteText={"Archive"}
				/>
			</div>
		)
	}
};

export default Framework.Components.withRootState(Ioi_Inspection)